import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.sort";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\01_WORK\\02_ClearTicket\\clearticket_pc\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import { getTicketInfo, changeTicket } from '@/api';
import { getNow } from '@/utils';
export default {
  props: {
    orderInfo: {
      type: Object,
      default: function _default() {
        return {
          tickets: [{}]
        };
      }
    }
  },
  components: {},
  data: function data() {
    return {
      visible: false,
      isshowInfo: true,
      tickets: [],
      selectedDate: '',
      showCalendar: false,
      selectedBatch: null,
      ticketBatches: [],
      ticketStart: '',
      ticketEnd: '',
      order: {},
      form: {
        count: 1,
        playDate: '',
        buyer_name: '',
        buyer_phone: '',
        buyer_identify: '',
        buyer_papers_type: 'ID_CARD',
        tickets: [{
          price: '',
          guest_identify: '',
          guest_name: '',
          guest_phone: '',
          play_date_begin: '',
          ticket_type_id: ''
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate() {
          return false;
        }
      }
    };
  },
  computed: {
    allowUserPartCancel: function allowUserPartCancel() {
      return this.$store.state.projectConfig.allow_user_part_cancel;
    }
  },
  methods: {
    getTicketBatch: function getTicketBatch() {
      var _this = this;

      this.loading = true;
      var params;

      if (!this.selectedDate) {
        params = {
          id: this.tickets[0].ticket_type.id
        };
      } else {
        params = {
          id: this.tickets[0].ticket_type.id,
          start: moment(this.selectedDate).format('YYYY-MM-DD'),
          end: moment(this.selectedDate).format('YYYY-MM-DD')
        };
      }

      getTicketInfo(params).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          var now;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.ticketType = res.data.extraInfo;
                  _this.ticketStart = new Date(moment().startOf('day'));
                  _this.ticketEnd = new Date(moment().add(_this.ticketType.book_future_days, 'days').valueOf());

                  _this.pickerOptions.disabledDate = function (time) {
                    return time.getTime() < _this.ticketStart.getTime() || time.getTime() > _this.ticketEnd.getTime();
                  };

                  _context.next = 6;
                  return getNow();

                case 6:
                  now = _context.sent;
                  _this.ticketBatches = res.data.extraInfo.batches.filter(function (item) {
                    if (item.stocks[0]) {
                      item.left_volume = item.stocks[0].sales_limit - item.stocks[0].sales_volume;
                    } else {
                      item.left_volume = 0;
                    }

                    return item.prices.length > 0 && moment(moment(_this.selectedDate).format('YYYY-MM-DD') + ' ' + item.book_today_endtime, 'YYYY-MM-DD HH:mm:ss').isAfter(moment(now)) && item.left_volume > 0;
                  });

                  _this.ticketBatches.sort(function (a, b) {
                    return moment(a.start_time, 'HH:mm:ss').isAfter(moment(b.start_time, 'HH:mm:ss')) ? 1 : -1;
                  });

                  console.log('this.ticketBatches', _this.ticketBatches);
                  _this.selectedBatch = _this.ticketBatches[0] || null;

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).finally(function () {
        _this.loading = false;
      });
    },
    getStock: function getStock(a) {
      if (!isNaN(Number(a))) {
        return "\u5269\u4F59:".concat(a);
      } else {
        return a;
      }
    },
    open: function open(order) {
      var _this2 = this;

      this.visible = true;
      this.order = order;

      if (order.tickets.some(function (item) {
        return item.status === 'CANCELED';
      }) && this.allowUserPartCancel) {}

      this.$nextTick(function () {
        _this2.tickets = _this2.order.tickets.filter(function (i) {
          return i.status !== 'CHANGED';
        });
        console.log('this.tickets', _this2.tickets);
        _this2.selectedDate = new Date(_this2.tickets[0].play_date_begin);

        _this2.getTicketBatch();
      });
      this.$emit('update');
    },
    changeticket: function changeticket() {
      var _this3 = this;

      if (!this.selectedBatch) {
        this.$message.error('请选择场次');
        return;
      }

      if (moment(this.selectedDate).format('YYYY-MM-DD') === this.tickets[0].play_date_begin && this.selectedBatch.id === this.tickets[0].batch_type_id) {
        this.$message.error('场次信息未修改，请重新选择');
        return;
      }

      var tickets = this.tickets.map(function (item) {
        var ticket = JSON.parse(JSON.stringify(item));
        ticket.batch_type_id = _this3.selectedBatch.id;
        ticket.origin_ticket_id = item.id;
        ticket.play_date_begin = moment(_this3.selectedDate).format('YYYY-MM-DD');
        return ticket;
      });
      console.log('this.order', this.order);
      var params = {
        tickets: tickets
      };
      console.log('params', params);
      this.$confirm('只可改签一次，改签后不可退票，确认改签吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        changeTicket(_this3.order.id, params).then(function (res) {
          console.log('res', res);

          _this3.$message.success('改签中');

          _this3.$emit('update');

          _this3.visible = false;
        }).finally(function () {});
      }).catch(function () {// on cancel
      });
    },
    getCodes: function getCodes(order) {
      return order.tickets ? order.tickets.map(function (t) {
        return t.selfservice_code;
      }).join('，') : '';
    }
  }
};